//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import numeric from "@/components/numeric";


export default {
  props: {
    article: {},
  },
   components:{
    numeric
  },
  data() {
    return { dense: true };
  },

  computed: {
    ...mapState("main", []),
  },

  methods: {
    ...mapActions("main", []),
  },
};
